export default "__VITE_ASSET__Dh3yth0C__"